import { AbiItem } from 'web3-utils';
import { Interface } from '@ethersproject/abi';
import { getWeb3, getWeb3NoAccount, getWeb3NoAccountBASE } from 'utils/web3';
import MultiCallAbi from 'config/abi/Multicall.json';
import { getMulticallAddress, getMulticallNativeAddress } from 'utils/addressHelpers';

interface Call {
  address: string; // Address of the contract
  name: string; // Function name on the contract (exemple: balanceOf)
  params?: any[]; // Function params
}

const multicall = async (abi: any[], calls: Call[]): Promise<any> => {
  const web3 = getWeb3NoAccount();
  const multi = new web3.eth.Contract(MultiCallAbi as unknown as AbiItem, getMulticallAddress());
  const itf = new Interface(abi);

  const calldata = calls.map((call) => [call.address.toLowerCase(), itf.encodeFunctionData(call.name, call.params)]);
  const { returnData } = await multi.methods.aggregate(calldata).call();
  const res = returnData.map((call: any, i: number) => itf.decodeFunctionResult(calls[i].name, call));

  return res;
};

export const multicallNative = async (abi: any[], calls: Call[]): Promise<any> => {
  const web3 = getWeb3NoAccountBASE();
  const multi = new web3.eth.Contract(MultiCallAbi as unknown as AbiItem, "0xcA11bde05977b3631167028862bE2a173976CA11");
  const itf = new Interface(abi);

  const calldata = calls.map((call) => [call.address.toLowerCase(), itf.encodeFunctionData(call.name, call.params)]);
  const { returnData } = await multi.methods.aggregate(calldata).call();
  const res = returnData.map((call: any, i: number) => itf.decodeFunctionResult(calls[i].name, call));

  return res;
};

export default multicall;
